import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "multipleBox" }
const _hoisted_2 = {
  key: 0,
  class: "sliderBox"
}
const _hoisted_3 = { class: "sliderPoint" }
const _hoisted_4 = { class: "sliderPointNum" }

import { ref, onMounted,watch } from 'vue'
import slider from '@/components/common/soliderNew.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'ttsMultiple',
  props: {
    multiple:Number,
    onOff:Boolean,
},
  emits: ['updateMultiple'],
  setup(__props, { emit: __emit }) {

let prope=__props
let emit=__emit
const multipleMin=ref(0)
watch(prope ,(n,o)=>{
    // console.log(n.onOff)
    if(n.onOff){
        multipleMin.value=JSON.parse(JSON.stringify(prope.multiple))*1
       
    }
})
const updataprotect=(num: number)=>{
    multipleMin.value = num;
    emit('updateMultiple',multipleMin.value)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(!_unref(prope).onOff? 'multipleNum' :'multipleNumsel')
    }, _toDisplayString(_unref(prope).multiple) + "X", 3),
    (_unref(prope).onOff)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _cache[0] || (_cache[0] = _createElementVNode("div", { class: "sliderTitle" }, "音频倍速", -1)),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(slider, {
              min: 0.1,
              max: 2,
              num: multipleMin.value,
              precision: true,
              onUpdataNum: updataprotect,
              class: "sliderStyle"
            }, null, 8, ["num"]),
            _createElementVNode("div", _hoisted_4, _toDisplayString(multipleMin.value) + " X", 1)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})